import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(rootSaga);

import { all } from 'redux-saga/effects'; // import watchAndLogActions from './watch-log-actions'

import watchLoadConfig from './watch-load-config';
import watchPantalla from './watch-pantalla';
import watchZona from './watch-zona';
import watchNotas from './watch-notas';
import watchEjecutarFuncion from './watch-ejecutar-funcion';
import { watchSeleccionarHerramienta, watchOcultarHerramientas } from './barra-herramientas';
import watchSesiones from './watch-sesiones';
import sagasPizarra from './pizarra';
import { watchTextosUsuario } from './textos-usuario';
export default function rootSaga() {
  return _regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return all([watchLoadConfig(), watchPantalla(), watchZona(), watchNotas(), watchEjecutarFuncion(), watchSeleccionarHerramienta(), watchOcultarHerramientas(), sagasPizarra(), watchTextosUsuario(), watchSesiones()]);

        case 3:
          _context.next = 8;
          break;

        case 5:
          _context.prev = 5;
          _context.t0 = _context['catch'](0);
          window.console.error(_context.t0);

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 5]]);
}